window.manifest = window.manifest || {};
manifest.clicked = false;

/* --- Price Range Slider --- */
$(document).ready(function() {
  const rangeInputs = document.querySelectorAll(".range-input input");
  const priceMinDisplay = document.querySelector(".price-display-min");
  const priceMaxDisplay = document.querySelector(".price-display-max");
  const progressBar = document.querySelector(".slider .progress");
  const priceGap = 100;

  // Price Range Listener (with null checks)
  if (rangeInputs.length >= 2 && priceMinDisplay && priceMaxDisplay && progressBar) {
    rangeInputs.forEach((input) => {
      input.addEventListener("input", (e) => {
        let minVal = parseInt(rangeInputs[0].value),
            maxVal = parseInt(rangeInputs[1].value);
        
        if (maxVal - minVal < priceGap) {
          if (e.target.className === "range-min") {
            rangeInputs[0].value = maxVal - priceGap;
          } else {
            rangeInputs[1].value = minVal + priceGap;
          }
        } else {
          priceMinDisplay.textContent = `$${minVal}`;
          priceMaxDisplay.textContent = `$${maxVal}`;
          progressBar.style.left = `calc(${(minVal / rangeInputs[0].max) * 100}% + 15px)`;
          progressBar.style.right = 100 - (maxVal / rangeInputs[1].max) * 100 + "%";
        }
        
        // Throttled update
        throttleUpdate(minVal, maxVal);
      });
    });
  }

  // Init Price Inputs from applied_filters
  if (typeof applied_filters === 'object' && applied_filters !== null) {
    const minPrice = applied_filters.min_price ?? 0;
    const maxPrice = applied_filters.max_price ?? 5000;

    if ($('.range-max').length) $('.range-max').val(maxPrice);
    if ($('.range-min').length) $('.range-min').val(minPrice);
    if ($('.price-display-min').length) $('.price-display-min').text(`$${minPrice}`);
    if ($('.price-display-max').length) $('.price-display-max').text(`$${maxPrice}`);
  }

  // Initial Load
  if (typeof applied_filters !== 'undefined' && applied_filters.year && applied_filters.make && applied_filters.model) {
    if (typeof getApiData === 'function') getApiData();
  } else {
    if ($('.open-ymm-modal').length) $('.open-ymm-modal')[0].click();
  }
});

/* --- Throttle for Price Updates --- */
let throttleTimeout;
let lastMin, lastMax;
const throttleDelay = 300;

function throttleUpdate(min, max) {
  lastMin = min;
  lastMax = max;

  if (!throttleTimeout) {
    throttleTimeout = setTimeout(() => {
      if (typeof updateFilters === 'function') {
        updateFilters({ 'max_price': lastMax, 'min_price': lastMin });
      }
      throttleTimeout = null;
    }, throttleDelay);
  }
}

/* --- HTML Generator for Product Card (Modern Dark Theme) --- */
function productGridItem(product) {
  const isSoldOut = product.tags && product.tags.indexOf('in_stock') === -1;
  const onSale = product.compare_at_price > product.price;
  const imageSrc = product.image || '';

  return `
    <li class="grid__item">
      <div class="modern-product-card">
        <div class="card-image-container">
          <a href="/products/${product.handle}" class="full-unstyled-link">
            <img src="${imageSrc}" alt="${product.title}" class="card-image" loading="lazy" width="533" height="533">
          </a>
          ${isSoldOut ? '<div class="card-badge sold-out">Sold Out</div>' : ''}
          ${!isSoldOut && onSale ? '<div class="card-badge sale">Sale</div>' : ''}
        </div>
        <div class="card-content">
          ${product.vendor ? `<div class="card-vendor">${product.vendor}</div>` : ''}
          <a href="/products/${product.handle}" class="card-title">${product.title}</a>
          <div class="card-price">
            <div style="display: flex; align-items: center; flex-wrap: wrap;">
              <span class="price-current">$${product.price} USD</span>
              ${onSale ? `<span class="price-compare">$${product.compare_at_price} USD</span>` : ''}
            </div>
          </div>
        </div>
      </div>
    </li>
  `;
}

/* --- Pagination Helper --- */
function extractPageNumber(url) {
  if (!url) return null;
  try {
    const urlObj = new URL(url);
    return urlObj.searchParams.get('page');
  } catch (e) {
    return null;
  }
}

function getPaginationHtmlContent(links) {
  let html = '<ul class="pagination-ymm">';
  $.each(links, (index, link) => {
    const activeClass = link.active ? 'active' : '';
    const disabledClass = link.url === null ? 'disabled' : '';
    const pageNumber = extractPageNumber(link.url);
    html += `
      <li class="page-item ${activeClass} ${disabledClass}" data-page="${pageNumber || ''}">
        <span class="page-link">${link.label}</span>
      </li>
    `;
  });
  html += '</ul>';
  return html;
}

/* --- Event Delegation --- */

// Pagination
$(document).on('click', '.page-item', function() {
  if (!$(this).hasClass('disabled')) {
    applied_filters.page = $(this).attr('data-page');
    if (typeof updateFilters === 'function') updateFilters({ page: applied_filters.page });
  }
});

// Sort Options
$(document).on('click', 'li.ymm-sort-option', function() {
  if (typeof updateFilters === 'function') {
    updateFilters({
      my_sort_by: $(this).attr('sort-by'),
      my_sort_order: $(this).attr('sort-order'),
      page: 1
    });
  }
  $('.wrapper-dropdown').removeClass('active');
});

// Category Checkboxes
$(document).on('change', 'input[name="Categories"]', function() {
  const selectedValues = $('input[name="Categories"]:checked').map(function() { return this.value; }).get();
  applied_filters.my_collection_id = selectedValues;
  if (typeof updateFilters === 'function') updateFilters({ my_collection_id: selectedValues, page: 1 });
});

// Brand Checkboxes
$(document).on('change', 'input[name="Brand"]', function() {
  const selectedBrands = $('input[name="Brand"]:checked').map(function() { return this.value; }).get();
  applied_filters.my_brand = selectedBrands;
  if (typeof updateFilters === 'function') updateFilters({ my_brand: selectedBrands, page: 1 });
});

// Product Type Checkboxes
$(document).on('change', 'input[name="Product"]', function() {
  const selectedProductTypes = $('input[name="Product"]:checked, input[name="product"]:checked').map(function() { return this.value; }).get();
  applied_filters.my_product_type = selectedProductTypes;
  if (typeof updateFilters === 'function') updateFilters({ my_product_type: selectedProductTypes, page: 1 });
});

// Clear All
$(document).on('click', '.manifest-ymm-filter-clearAllBtn', function() {
  if (typeof updateFilters === 'function') {
    updateFilters({ page: 1, my_collection_id: null, my_sort_by: null, my_sort_order: null, my_product_type: null, my_brand: null });
  }
  $('input[type="checkbox"]').prop('checked', false);
  $('.manifest-ymm-filters').removeClass('active');
});

// Mobile Filter Drawer Toggles
$(document).on('click', '#manifest_ymm_filter_open', function() {
  $('.manifest-ymm-filters').addClass('active');
});

$(document).on('click', '#filter_close, #filter_apply', function() {
  $('.manifest-ymm-filters').removeClass('active');
});

// Mobile Sort Drawer Toggles
$(document).on('click', '#manifest_ymm_sort_by', function() {
  $('#mobile-sort-drawer').addClass('active');
});

$(document).on('click', '#close-sort-drawer, .sort-drawer-overlay', function() {
  $('#mobile-sort-drawer').removeClass('active');
});

// Mobile Sort Option Click
$(document).on('click', '.sort-drawer-options .sort-option', function() {
  const sortBy = $(this).data('sort-by');
  const sortOrder = $(this).data('sort-order');
  
  // Update active state
  $('.sort-drawer-options .sort-option').removeClass('active');
  $(this).addClass('active');
  
  // Update the desktop dropdown display too
  $('#destination').text($(this).text());
  
  // Apply sort
  if (typeof updateFilters === 'function') {
    updateFilters({
      my_sort_by: sortBy,
      my_sort_order: sortOrder,
      page: 1
    });
  }
  
  // Close drawer
  $('#mobile-sort-drawer').removeClass('active');
});

// Accordion Logic
$(document).on('click', '.manifest-ymm-filter-group-header', function() {
  $(this).parent().toggleClass('active');
});

// Search Input Logic (Client Side Filter)
$(document).on('keyup', '.search-input', function() {
  var value = $(this).val().toLowerCase();
  $(this).closest('.manifest-ymm-filter-group-content').find('li').filter(function() {
    $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
  });
});

/* --- Custom Dropdown Logic --- */
$(document).ready(function() {
  // Toggle dropdown on click
  $(document).on('click', '.wrapper-dropdown', function(e) {
    e.stopPropagation();
    $(this).toggleClass('active');
  });

  // Close dropdown when clicking outside
  $(document).on('click', function(e) {
    if (!$(e.target).closest('.wrapper-dropdown').length) {
      $('.wrapper-dropdown').removeClass('active');
    }
  });
});
